import {
    Col,
    Flex,
    Form,
    Input,
    Modal,
    Select,
    Button,
    Row,
    Typography,
  } from "antd";
  import React, { useCallback, useEffect } from "react";
  import { useState } from "react";
import { useTranslation } from "react-i18next";
  import { useDispatch, useSelector } from "react-redux";
  import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../../../common/customTitle";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import { getSystemSettingsAction } from "../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
import { colors } from "../../../../../constants/colors";
import Actions from "../../../../../redux/actions";
import { baseRouteMaker, routes } from "../../../../../constants/routeConsts";
  
  const StaffRenewalDialog = ({ open, onClose }) => {
    /* i18n dependencies */
    const { t } = useTranslation();
    /* i18n dependencies */
  
    /* For navigating between pages */
    const navigate = useNavigate();
    /* For navigating between pages */
  
    /* dispatch an action */
    const dispatch = useDispatch();
    /* dispatch an action */
  
    /* form dependencies */
    const [form] = Form.useForm();
    /* form dependencies */
  
    /* loading dependencies */
    const [loading, setLoading] = useState(false);
    const [selectListLoader] = useState(false);
    /* loading dependencies */
  
    const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
    const { selectedStaffId } = useSelector((state) => state.staff);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
  
    const handleGetTableData = useCallback(() => {
      dispatch(getSystemSettingsAction(setLoading));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    useEffect(() => {
      handleGetTableData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  
    const handleDialogClose = () => {
      onClose();
      form.resetFields();
      setSelectedPeriod(null);
      dispatch(
        Actions.createAction(Actions.SELECTED_STAFF_ID, { selectedStaffId: "" })
      );
    };
  
    const onPeriodChanged = (id) => {
      const selectedPeriodObj = systemSettings?.addon_account_charges?.find(
        (element) => element._id === id
      );
      const tempSelectedPeriodObj = {
        ...selectedPeriodObj,
        currency: systemSettings?.system_currency,
      };
      setSelectedPeriod(tempSelectedPeriodObj);
    };
  
    /* on submit */
    const onSubmit = () => {
      if (
        selectedStaffId &&
        selectedStaffId !== "" &&
        selectedStaffId !== undefined &&
        selectedStaffId !== null
      ) {
        const dataToBeSent = {
          event_type: "STAFF_RENEWAL",
          ...selectedPeriod,
          purchase_type: "renewal",
          user_id : selectedStaffId
        };
        dataToBeSent["_id"] = selectedStaffId;
  
        dispatch(
          Actions.createAction(
            Actions.SELECTED_STAFF_RENEWAL_DETAILS,
            { selectedStaffRenewalDetails: dataToBeSent }
          )
        );
        dispatch(Actions.createAction(Actions.CLEAR_COUPON));
        navigate(baseRouteMaker(routes.STAFF_RENEWAL_PAYMENT));
      }
    };
    /* on submit */
  
    return (
      <Modal
        open={open}
        onCancel={handleDialogClose}
        footer={false}
        confirmLoading={loading}
        width={400}
      >
        <Flex vertical gap="3rem" align="center" justify="center">
          <CustomTitle textDecoration="underline" justifyContent="center">
            Buy Renewal
          </CustomTitle>
        </Flex>
        <Form
          style={{ marginTop: 20 }}
          form={form}
          layout="vertical"
          autoComplete="off"
          requiredMark={false}
          onFinish={onSubmit}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                name="duration"
                label={
                  <RequiredLabel text={t("Modules.Ads.period")} required={true} />
                }
                rules={[
                  {
                    required: true,
                    message: t("Modules.Ads.pleaseSelectPeriod"),
                  },
                ]}
              >
                <Select
                  loading={selectListLoader}
                  options={systemSettings?.addon_account_charges?.map(
                    (element) => ({
                      value: element._id,
                      label: `${element.duration} month${
                        element.duration > 1 ? "s" : ""
                      }`,
                      price: `${element.price} ${element.currency}`,
                      currency: systemSettings?.system_currency,
                    })
                  )}
                  onChange={(value) => onPeriodChanged(value)}
                  placeholder={t("Modules.Ads.selectPeriod")}
                />
              </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
            {selectedPeriod &&
                selectedPeriod !== null &&
                selectedPeriod !== undefined && (
                  <Flex gap="0.8rem">
                    <Flex gap="0.8rem" align="center" justify="center">
                      <Typography.Title
                        level={2}
                        style={{
                          color: colors.royalPurple,
                          margin: 0,
                        }}
                      >
                        {selectedPeriod
                          ? `${selectedPeriod?.price} ${selectedPeriod?.currency}`
                          : ""}
                      </Typography.Title>
                      <Typography.Title
                        level={2}
                        style={{
                          color: colors.royalPurple,
                          margin: 0,
                        }}
                      >
                        / {t("CommonUtils.each")}
                      </Typography.Title>
                    </Flex>

                    {Number(selectedPeriod?.duration) !== 1 && (
                      <Typography.Title
                        level={5}
                        style={{
                          color: colors.royalPurple,
                          margin: 0,
                          textDecoration: "line-through",
                        }}
                      >
                        {selectedPeriod
                          ? `${
                              selectedPeriod?.duration *
                              (systemSettings?.addon_account_charges?.find(
                                (element) => Number(element.duration) === 1
                              )?.price || 50)
                            } ${selectedPeriod?.currency}`
                          : ""}
                      </Typography.Title>
                    )}
                  </Flex>
                )}
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
              >
                {t("CommonUtils.pay")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };
  
  export default StaffRenewalDialog;
  